import PropTypes from 'prop-types'

export class ButtonType {
  static NORMAL = 0
  static ACTION = 1
  static WARNING = 2
  static LINK = 3
}

export class ButtonActionType {
  static ADD = 0
  static REMOVE = 1
  static DELETE = 2
  static EDIT = 3
  static SHARE = 4
  static CANCEL = 5
  static YES = 6
  static NO = 7
}

export const ButtonVariantTypes = {
  [ButtonActionType.ADD]: 'contained',
  [ButtonActionType.REMOVE]: 'contained',
  [ButtonActionType.DELETE]: 'contained',
  [ButtonActionType.EDIT]: 'contained',
  [ButtonActionType.SHARE]: 'contained',
  [ButtonActionType.CANCEL]: 'text',
  [ButtonActionType.YES]: 'contained',
  [ButtonActionType.NO]: 'text',
}

export const ButtonColorTypes = {
  [ButtonActionType.ADD]: 'primary',
  [ButtonActionType.REMOVE]: 'error',
  [ButtonActionType.DELETE]: 'error',
  [ButtonActionType.EDIT]: 'primary',
  [ButtonActionType.SHARE]: 'primary',
  [ButtonActionType.CANCEL]: 'secondary',
  [ButtonActionType.YES]: 'primary',
  [ButtonActionType.NO]: 'secondary',
}

export const ActionPropTypes = {
  link: PropTypes.func,
  icon: PropTypes.any,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    ButtonType.NORMAL,
    ButtonType.ACTION,
    ButtonType.WARNING,
    ButtonType.LINK,
  ]).isRequired,
  exec: PropTypes.func.isRequired,
  disabled: PropTypes.func.isRequired,
  hidden: PropTypes.func.isRequired,
}

/*eslint-disabled */
export class ButtonData {
  /**
   *
   * @param {ButtonType} type
   * @param {string} title
   * @param {ButtonActionType} actionType
   * @param {any} exec
   * @param {string} color
   * @param {boolean|function} disabled
   */
  constructor(type, title, actionType, exec, color, disabled = false) {
    this._type = type
    this._title = title
    this._actionType = actionType
    this._exec = exec
    this._color = color
    this._disabled = disabled
  }

  /**
   * @returns {ButtonType}
   */
  get type() {
    return this._type
  }

  /**
   * @returns {string}
   */
  get title() {
    return this._title
  }

  /**
   * @returns {ButtonActionType}
   */
  get actionType() {
    return this._actionType
  }

  /**
   * @returns {any}
   */
  get exec() {
    return this._exec
  }

  /**
   * @returns {string}
   */
  get color() {
    return this._color
  }

  /**
   * Returns whether the button is disabled
   * @returns {boolean}
   */
  get disabled() {
    return typeof this._disabled === 'function'
      ? this._disabled()
      : !!this._disabled
  }

  /**
   * @returns {Object}
   */
  toJSON() {
    return {
      type: this._type,
      title: this._title,
      actionType: this._actionType,
      exec: this._exec,
      color: this._color,
      disabled: this.disabled,
    }
  }
}
/*eslint-enabled */
